module.exports = __webpack_public_path__ + "img/placeholder-profitLoss.b384b8c5.png";